(() => {
  document.querySelectorAll('[data-nv-fit]').forEach(root => {
    if (root.dataset.ready) return;
    const form = root.querySelector('form');
    const status = root.querySelector('[data-fit-status]');
    const items = Array.from(root.querySelectorAll('[data-fit-item]'));
    const clear = () => {
      items.forEach(item => { item.hidden = false; item.querySelector('[data-fit-match]').hidden = true; });
      status.textContent = root.dataset.initial;
    };
    form.addEventListener('submit', event => {
      event.preventDefault();
      const values = Object.fromEntries(['width','depth','height','reserve'].map(name => [name, form.elements.namedItem(name).valueAsNumber]));
      if (!Object.values(values).every(Number.isFinite) || values.width <= 0 || values.depth <= 0 || values.height <= 0 || values.reserve < 0 || values.reserve >= values.width) {
        clear(); status.textContent = root.dataset.error; return;
      }
      let count = 0;
      items.forEach(item => {
        const width = Number(item.dataset.width), height = Number(item.dataset.height);
        const depthKnown = item.dataset.depth !== '';
        const fits = item.dataset.available === 'true' && width <= values.width - values.reserve + 1e-9 && height <= values.height + 1e-9 && (!depthKnown || Number(item.dataset.depth) <= values.depth + 1e-9);
        item.hidden = !fits; item.querySelector('[data-fit-match]').hidden = !fits;
        if (fits) count++;
      });
      status.textContent = count ? root.dataset.count.replace('{count}', String(count)) : root.dataset.none;
    });
    form.addEventListener('reset', clear);
    root.dataset.ready = 'true'; form.hidden = false;
  });
})();